<template>
    <div v-if="isUpdata" class="record_wrap">
        <div class="record_list">
            <div class="record_item">
                <div class="label">合同<br/>类型</div>
                <div class="item"><p>正式合同</p></div>
                <div class="item"><p>变更合同</p></div>
            </div>
            <div class="record_item">
                <div class="label">审核<br/>状态</div>
                <div :class="{'item':true,
                              'green_state':contractInfo.status == 1 || contractInfo.status == 3,
                              'orange_state':contractInfo.status == 2,
                              'red_state':contractInfo.status == 4 || contractInfo.status == 5}">
                    <p>{{ contractInfo.new_approvalstatus }}</p></div>
                <div :class="{'item':true,
                              'green_state':changeInfo.status == 1 || changeInfo.status == 3,
                              'orange_state':changeInfo.status == 2,
                              'red_state':changeInfo.status == 4 || changeInfo.status == 5}">
                    <p>{{ changeInfo.new_approvalstatus }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">合同<br/>编号</div>
                <div class="item"><p>{{ contractInfo.new_code || '--' }}</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_code || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">是否项<br/>目终止</div>
                <div class="item"><p>{{ contractInfo.new_isterminate || '--' }}</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_isterminate || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">项目<br/>类型</div>
                <div class="item"><p>{{ contractInfo.new_projecttype || '--' }}</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_projecttype || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">设备销<br/>售总价</div>
                <div class="item"><p>{{ contractInfo.new_salesamount || 0 }}元</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_salesamount || 0 }}元</p></div>
            </div>
            <div class="record_item">
                <div class="label">系统安<br/>装总价</div>
                <div class="item"><p>{{ contractInfo.new_installamount || 0 }}元</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_installamount || 0 }}元</p></div>
            </div>
            <div class="record_item">
                <div class="label">合同<br/>总金额</div>
                <div class="item"><p>{{ contractInfo.new_totalamount || 0 }}元</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_totalamount || 0 }}元</p></div>
            </div>
            <div class="record_item">
                <div class="label">开票<br/>方式</div>
                <div class="item"><p>{{ contractInfo.new_invoicetype || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_invoicetype || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">信息<br/>来源</div>
                <div class="item"><p>{{ contractInfo.new_account_source || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_account_source || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">门店<br/>信息</div>
                <div class="item"><p>{{ contractInfo.new_store_id || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_store_id || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">锅炉<br/>合同号</div>
                <div class="item"><p>{{ contractInfo.new_contractbillno || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_contractbillno || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">系统<br/>合同号</div>
                <div class="item"><p>{{ contractInfo.new_contractbillno2 || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_contractbillno2 || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">锅炉<br/>妥投码</div>
                <div class="item"><p>{{ contractInfo.new_delievered1 || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_delievered1 || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">系统<br/>妥投码</div>
                <div class="item"><p>{{ contractInfo.new_delievered2 || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_delievered2 || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">收费<br/>情况</div>
                <div class="item"><p>{{ contractInfo.new_ischarge || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_ischarge || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">减免<br/>金额</div>
                <div class="item"><p>{{ contractInfo.new_reductionamount || '--' }}</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_reductionamount || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">付款<br/>方式</div>
                <div class="item"><p>{{ contractInfo.new_paymenttype || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_paymenttype || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">收款<br/>渠道</div>
                <div class="item"><p>{{ contractInfo.new_paymentchannel || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_paymentchannel || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">收退款<br/>渠道</div>
                <div class="item"><p>{{ contractInfo.new_changepaymentchannel || '--' }}</p></div>
                <div class="item"><p>{{ changeInfo.new_changepaymentchannel || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">收款<br/>时间</div>
                <div class="item"><p>{{ handleTime(contractInfo.new_secondpaymentdate) }}</p></div>
                <div class="item"><p>{{ handleTime(changeInfo.new_secondpaymentdate) }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">变更<br/>描述</div>
                <div class="item"><p>{{ contractInfo.new_memo || '--' }}</p></div>
                <div class="item"><p class="red">{{ changeInfo.new_memo || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">审批<br/>时间</div>
                <div class="item"><p>{{ handleTime(contractInfo.new_approved_time) }}</p></div>
                <div class="item"><p>{{ handleTime(changeInfo.new_approved_time) }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">合同<br/>附件</div>
                <div class="item">
                    <p v-if="contractInfo.contract_attach.length > 0" class="blue_line"
                       @click="toouchFile(contractInfo.contract_attach)">附件</p>
                    <p v-else>--</p>
                </div>
                <div class="item">
                    <p v-if="changeInfo.contract_attach.length > 0" class="red_line"
                       @click="toouchFile(changeInfo.contract_attach)">附件</p>
                    <p v-else>--</p>
                </div>
            </div>
            <div class="record_item">
                <div class="label">付款 <br/>凭证</div>
                <div class="item">
                    <p v-if="contractInfo.payment_attach.length > 0" class="blue_line"
                       @click="toouchFile(contractInfo.payment_attach)">附件</p>
                    <p v-else>--</p>
                </div>
                <div class="item">
                    <p v-if="changeInfo.payment_attach.length > 0" class="red_line"
                       @click="toouchFile(contractInfo.payment_attach)">附件</p>
                    <p v-else>--</p>
                </div>
            </div>

            <div class="record_item">
                <div class="label">方案或<br/>配置表</div>
                <div class="item">
                    <p v-if="contractInfo.plan_attach.length > 0" class="blue_line"
                       @click="toouchFile(contractInfo.plan_attach)">附件</p>
                    <p v-else>--</p>
                </div>
                <div class="item">
                    <p v-if="changeInfo.plan_attach.length > 0" class="red_line"
                       @click="toouchFile(changeInfo.plan_attach)">附件</p>
                    <p v-else>--</p>
                </div>
            </div>
            <div class="record_item">
                <div class="label">产品<br/>数量</div>
                <div class="item"><p>{{ contractInfo.product_num || '--' }}</p></div>
                <div class="item"><p class="red">{{ changeInfo.product_num || '--' }}</p></div>
            </div>
            <div class="record_item">
                <div class="label">产品<br/>型号</div>
                <div class="item list">
                    <template v-if="contractInfo.product_list.length > 0">
                        <p v-for="(item,index) in contractInfo.product_list">{{ item.name }}</p>
                    </template>
                    <template v-else>
                        <p>--</p>
                    </template>
                </div>
                <div class="item list">
                    <template v-if="changeInfo.product_list.length > 0">
                        <p v-for="(item,index) in changeInfo.product_list" :class="{'red':item.is_add}">
                            {{ item.name }}
                        </p>
                    </template>
                    <template v-else>
                        <p>--</p>
                    </template>
                </div>
            </div>
        </div>

        <img class="back_icon" @click="touchBack" src="~@/assets/images/archives/dossier/back_icon.png" />

    </div>
</template>

<script>
import {getRecordInfo} from "@/js/archives/dossier";
import {ImagePreview} from "vant";

export default {
    name: "ContractRecord",
    data() {
        return {
            isUpdata: false,
            contractInfo: {},
            changeInfo: {},
        }
    },
    mounted() {
        this.getRecordInfoFun()
    },
    methods: {
        getRecordInfoFun() {
            this.$store.commit("loadSwitch", true);
            getRecordInfo({
                contract_id: this.$route.query.contract_id,
                change_id: this.$route.query.change_id
            }).then((res) => {
                this.isUpdata = true;
                console.log('getRecordInfo', res.data.data.result)
                this.contractInfo = res.data.data.result.contract || {};
                this.changeInfo = res.data.data.result.change || {};
                this.$store.commit("loadSwitch", false);
            })
        },
        handleTime(time) {
            let num = new Date(time).getTime();
            if (num) {
                let arr = time.split(' ');
                return arr[0].replaceAll('-', '.')
            } else {
                return time || '--'
            }
        },
        toouchFile(img) {
            ImagePreview(img)
        },
        touchBack(){
            this.$router.back()
        }
    }
}
</script>

<style lang="scss" scoped>

.record_wrap {
    width: 100%;
    min-height: 100%;
    background: #F9F9FB;
    padding: 32px 0 calc(32px + env(safe-area-inset-bottom));
}

.record_list {
    width: 686px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.0500);
    margin: 0 auto;
    position: relative;

    .record_item {
        width: 100%;
        min-height: 128px;
        display: flex;
        padding: 46px 0;

    }

    .record_item:nth-child(1) {
        border-radius: 16px 16px 0 0;
    }

    .record_item:nth-last-child(1) {
        border-radius: 0 0 16px 16px;
    }

    .record_item:nth-child(2n - 1) {
        background: #FFFFFF;

    }

    .record_item:nth-child(2n) {
        background: #F9F9FB;
    }

    .label {
        width: 142px;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: $greyText;
        line-height: 32px;
        text-align: center;
    }

    .item {
        width: calc((100% - 143px) / 2);
        text-align: center;
        color: #555555;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 34px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
    }

    .list {
        padding-top: 16px;
        justify-content: flex-start;

        p {
            margin-bottom: 16px;
        }
    }


    .green_state {
        p {
            width: 128px;
            height: 40px;
            line-height: 40px;
            color: #FFFFFF;
            background: #74B176;
            border-radius: 20px;
            margin: 0 auto;
        }
    }

    .orange_state {
        p {
            width: 128px;
            height: 40px;
            line-height: 40px;
            color: #FFFFFF;
            background: #EEB038;
            border-radius: 20px;
            margin: 0 auto;
        }
    }

    .red_state {
        p {
            width: 128px;
            height: 40px;
            line-height: 40px;
            color: #FFFFFF;
            background: #E95859;
            border-radius: 20px;
            margin: 0 auto;
        }
    }

    .blue_line {
        color: #0D53FC;
        border-bottom: 1px solid #0D53FC;
    }

    .red {
        color: #E95859;
    }

    .red_line {
        color: #E95859;
        border-bottom: 1px solid #E95859;
    }
}


.record_list::after {
    content: "";
    position: absolute;
    top: 0;
    left: 141px;
    display: block;
    width: 2px;
    height: 100%;
    background: #EEEEEE;
    z-index: 10;
}

.back_icon {
    position: fixed;
    left: 32px;
    bottom: calc(env(safe-area-inset-bottom) + 150px);
    z-index: 999;
    width: 100px;
    height: 100px;
}

</style>
